/**
 * Events hero / intro section. Same structure as M List; twentytwentysix design language.
 */
import React from "react";
import { Link } from "react-router-dom";

export default function EventsHeroIntroSection() {
  return (
    <>
      <p className="twentytwentysix-content__eyebrow">The Mamahood</p>
      <h1 className="twentytwentysix-content__title">What&apos;s Happening Now</h1>
      <p className="twentytwentysix-content__copy">
        Virtual and in-person events for Bay Area mamas. Connect with local moms, join workshops, and show up for yourself and your community.
      </p>
      <div className="twentytwentysix-content__cta-row">
        <Link to="/twentytwentysix" className="twentytwentysix-content__pill">
          Back to Home
        </Link>
      </div>
    </>
  );
}
